import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { msg } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { AppBar, Box, IconButton, Toolbar, Typography, useTheme } from '@mui/material'
import LogoutIcon from '@mui/icons-material/Logout'
import useLogout from '../../hooks/useLogout'
import OrganizationIcon from '../OrganizationIcon'
import useOnlineStatus from '../../hooks/useOnlineStatus'

export default function MobileTopNav () {
  const isOnline = useOnlineStatus()
  const theme = useTheme()
  const location = useLocation()
  const { state, state: { token, init } } = location
  const navigate = useNavigate()
  const { _ } = useLingui()

  const logout = useLogout()

  useEffect(() => {
    if (!token) logout()
  }, [logout, token])

  return (
    <AppBar sx={{
      boxShadow         : 1
      , backgroundColor : theme.palette.background.default
    }}>
      <Toolbar sx={{display: 'flex',alignItems:'center',backgroundColor: theme.palette.newColors.gray}}>
        <img src='../assets/ADaMS_Logo_White_12_06.png' alt='ADaMS logo' style={{ width: 120, maxWidth: 150 }} />
        <Typography component="div" sx={{ flexGrow: 1 }}></Typography>
        <Box display='flex' alignItems='center' color={theme.palette.text.primary}>
          {Object.keys(init).length &&
            <>
              <Typography variant="button" sx={{color:'white'}} pr={1.5}>{init.user.username}</Typography>
              <IconButton
                size='large'
                aria-label={_(msg`account of current user`)}
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={() => navigate('/user', { state })}
              >
                <OrganizationIcon isMobile={true} organization={init.user.organization} userType={init.user.type} style={{ color: '#4a4a4a', fontSize: 24 }} />
              </IconButton>
            </>}
          <Box p={1.5} display='flex' flexDirection='column' alignItems='center'>
            <Typography fontSize={theme.spacing(1.5)}>{isOnline ? '🟢' : '🔴'}</Typography>
            <Typography sx={{color:'white'}} fontSize={theme.spacing(1)}>{isOnline ? 'ONLINE' : 'OFFLINE'}</Typography>
          </Box>
          <IconButton
            edge='end'
            size="large"
            aria-label={_(msg`logout`)}
            aria-controls="menu-appbar"
            aria-haspopup="false"
            onClick={() => logout()}
          >
            <LogoutIcon sx={{color: 'white'}} />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  )
}

// <p>{isOnline ? "You are connected to the internet." : "You are offline. Some features may not be available."}</p>
